/**
 * Shared wishlist (localStorage) — used by header, product page, wishlist page.
 * Storage key: valliani_wishlist
 * Item shape: { id, handle, title, url, image, price }
 */
(function () {
  'use strict';

  var KEY = 'valliani_wishlist';
  var EVENT = 'valliani:wishlist:updated';

  function normalizeList(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (item) {
        if (item == null) return null;
        if (typeof item === 'string' || typeof item === 'number') {
          return { id: String(item), handle: '', title: '', url: '', image: '', price: '' };
        }
        return {
          id: String(item.id || ''),
          handle: item.handle || '',
          title: item.title || '',
          url: item.url || '',
          image: item.image || '',
          price: item.price || ''
        };
      })
      .filter(function (item) {
        return item && item.id;
      });
  }

  function getWishlist() {
    try {
      return normalizeList(JSON.parse(localStorage.getItem(KEY) || '[]'));
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    var normalized = normalizeList(list);
    localStorage.setItem(KEY, JSON.stringify(normalized));
    document.dispatchEvent(
      new CustomEvent(EVENT, {
        detail: { count: normalized.length, items: normalized }
      })
    );
    syncHeaderCount(normalized.length);
    return normalized;
  }

  function isInWishlist(productId) {
    var id = String(productId || '');
    if (!id) return false;
    return getWishlist().some(function (item) {
      return String(item.id) === id;
    });
  }

  function toggleWishlist(product) {
    if (!product || !product.id) return { added: false, list: getWishlist() };
    var id = String(product.id);
    var list = getWishlist();
    var idx = list.findIndex(function (item) {
      return String(item.id) === id;
    });

    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      return { added: false, list: list };
    }

    list.push({
      id: id,
      handle: product.handle || '',
      title: product.title || '',
      url: product.url || '',
      image: product.image || '',
      price: product.price || ''
    });
    saveWishlist(list);
    return { added: true, list: list };
  }

  function removeFromWishlist(productId) {
    var id = String(productId || '');
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== id;
    });
    saveWishlist(list);
    return list;
  }

  function syncHeaderCount(count) {
    if (typeof count !== 'number') count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-empty', count === 0);
      el.hidden = count === 0;
      var link = el.closest('a');
      if (link) link.setAttribute('data-wishlist-count-value', String(count));
    });
  }

  window.VallianiWishlist = {
    KEY: KEY,
    EVENT: EVENT,
    get: getWishlist,
    save: saveWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    syncHeaderCount: syncHeaderCount
  };

  function boot() {
    syncHeaderCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener(EVENT, function (e) {
    var count = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : getWishlist().length;
    syncHeaderCount(count);
  });
})();
